import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { fmtMoney } from "@/lib/format";

export const RefundDialog = ({ charge, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const close = () => { setReason(""); onClose(); };
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/charges/${charge.id}/refund`, { reason: reason.trim() });
      toast.success("Cobro marcado como reembolsado");
      close(); onDone();
    } catch (e) { toast.error(apiError(e).message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!charge} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="sm:max-w-md" data-testid="refund-dialog">
        <DialogHeader>
          <DialogTitle>¿Reembolsar este cobro?</DialogTitle>
          <DialogDescription>
            {charge && <>Se marcará como <b>Reembolsado</b> el monto completo de <b>{fmtMoney(charge.amount_cents, charge.currency)}</b> de {charge.guest_name || "este huésped"} y se descontará del total de ventas. </>}
            Este botón no devuelve el dinero: haz el reembolso en el procesador (Stripe, Whop, Clip, etc.).
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="refund-reason">Motivo del reembolso<span className="ml-0.5 text-rose-500">*</span></Label>
          <Textarea id="refund-reason" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ej. Cancelación de la reservación" data-testid="refund-reason-input" />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={close} data-testid="refund-cancel-btn">Volver</Button>
          <Button onClick={submit} disabled={busy || reason.trim().length < 3} className="bg-violet-600 hover:bg-violet-700" data-testid="refund-confirm-btn">
            {busy ? "Guardando…" : "Marcar como reembolsado"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
